import type React from 'react';
import { EMPTY_ARRAY, EMPTY_OBJECT, useTenderDetails } from '../../contexts/TenderDetailsContext';
import ProposalStructure from './ProposalStructure';
import WorkflowStep from './WorkflowStep';

const StructureAndOutlineStep: React.FC = () => {
  const {
    canManageTender,
    openStep,
    setOpenStep,
    stepCompletion,
    toggleStepCompletion,
    proposalStructure,
    setProposalStructure,
    removeHeading,
    isUploadingStructure,
    handleStructureFileUpload,
    downloadStructureTemplate,
    sensors,
    handleDragEnd,
    handleHeadingUpdate,
    handleFocuserUpdate,
    tender,
    handleLoadExtractedStructure,
    selectedTemplates,
    availableTemplates,
    handleSaveStructureAsDefault,
    setIsSavingDefault,
    account,
    quickSettings,
    handleQuickSettingsChange,
    handleDownload,
  } = useTenderDetails();

  if (!canManageTender) {
    return null;
  }

  return (
    <WorkflowStep
      stepNumber={7}
      expanded={openStep === 7}
      onChange={(_, isExpanded) => setOpenStep(isExpanded ? 7 : null)}
      title="Structure & Outline"
      description="Define the document headings and structure."
      isComplete={!!stepCompletion[7]}
      onToggleComplete={() => toggleStepCompletion(7)}
    >
      <ProposalStructure
        proposalStructure={proposalStructure}
        setProposalStructure={setProposalStructure}
        onRemoveHeading={removeHeading}
        isUploadingStructure={isUploadingStructure}
        onStructureFileUpload={handleStructureFileUpload}
        onDownloadStructureTemplate={downloadStructureTemplate}
        sensors={sensors}
        onDragEnd={handleDragEnd}
        onHeadingUpdate={handleHeadingUpdate}
        onFocuserUpdate={handleFocuserUpdate}
        canLoadExtractedStructure={
          !!(tender?.extractedStructure && tender.extractedStructure.length > 0)
        }
        canLoadHybridExtractedStructure={
          !!(tender?.hybridExtractedStructure && tender.hybridExtractedStructure.length > 0)
        }
        onLoadExtractedStructure={handleLoadExtractedStructure}
        selectedTemplate={selectedTemplates.draft || 'system_default'}
        mergeFields={(() => {
          if (!selectedTemplates.draft || selectedTemplates.draft === 'system_default') {
            return ['INSERT EXECUTIVE SUMMARY', 'INSERT DRAFT SECTIONS'];
          }
          if (tender?.draftTemplateMergeFields && tender.draftTemplateMergeFields.length > 0) {
            return tender.draftTemplateMergeFields;
          }
          const customTemplate = availableTemplates.find(
            // biome-ignore lint/suspicious/noExplicitAny: Expected
            (t: any) => t.id === selectedTemplates.draft
          );
          if (customTemplate?.validTagsFound && customTemplate.validTagsFound.length > 0) {
            return customTemplate.validTagsFound;
          }
          return [];
        })()}
        onSaveStructureAsDefault={() =>
          handleSaveStructureAsDefault(proposalStructure, setIsSavingDefault)
        }
        savedStructureTemplate={account?.customProposalStructure}
        detectedForms={tender?.detectedForms || EMPTY_ARRAY}
        detectedFormLinks={tender?.detectedFormLinks || EMPTY_OBJECT}
        enabledForms={quickSettings.enabledForms || EMPTY_ARRAY}
        onEnabledFormsChange={(forms) => handleQuickSettingsChange({ enabledForms: forms })}
        onDownloadForm={(url, filename) => handleDownload(url, 'detected_form', filename)}
      />
    </WorkflowStep>
  );
};

export default StructureAndOutlineStep;
